import React, { useEffect, useContext, useState, useRef } from 'react'

import Moment from 'moment'
import 'moment/locale/fr'
import { Divider, Box, Dialog, Button, TextField, FormControl, Select, MenuItem, Table, TableContainer, TableRow, TableBody, TableHead, TableCell, Paper } from '@mui/material'

import { ReactComponent as XIcon } from '../../../../images/x-icon.svg'
import loadingGIF from '../../../../images/loadingGIF.gif'
import { Trash2 as TrashIcon } from 'react-feather';
import { Download as DownloadIcon } from 'react-feather';
import { Edit as EditIcon } from 'react-feather';

import isEmail from "validator/lib/isEmail"
import {
  CHAMPS, contenuVide, estContenuRisingUp, genererHtml, avecExemples, contenuDepuisUnlayer,
  versChamps, depuisChamps, lienValide, TYPES_EMAIL, preremplir, objetAvecValeurs,
  contenuComplet, envoiChange, corpsDeRequete,
} from './emailRisingUp'
import { useConfirm } from "material-ui-confirm";

import { SocketContext } from "../../../../contexts/SocketContext"
import UserContext from "../../../../contexts/UserContext"

import APIS from "../../../../utils/APIS"


Moment.locale('fr')

/* ⛔ L'EDITEUR DES EMAILS (decision d'Hicham du 02/10/2026, choix « B »).
   L'editeur Unlayer (externe, charge depuis ses serveurs en « latest », en
   anglais, page vide a chaque email, date d'envoi en « Delta timing ») est
   remplace par une mise en page FIXE a la charte : on remplit un titre, un
   texte et un bouton (emailRisingUp.js). Le serveur ne change pas : memes
   champs, meme HTML enregistre, memes `{{...}}` remplaces a l'envoi.
   Un email ou un modele fait avec Unlayer part TEL QUEL tant qu'on ne le
   reecrit pas ; « Reecrire » recupere son texte dans le nouvel editeur. */
const STYLE_LIBELLE = { fontSize:"14px", fontWeight:"bold", marginBottom:"6px" }
const STYLE_BLOC = { marginBottom:"18px" }

const DialogContent = ({ title, subTitle, onClose, moduleInfos, groupeID, groupeName, getMailingForThisContent, mailings, actEditMailing, user }) => {

  const muiConfirm = useConfirm();
  const texteRef = useRef(null)

  const existant = (mailings && actEditMailing) ? mailings.find((el) => el.id === actEditMailing) : null
  const lireJSON = (s) => { try { return JSON.parse(s) } catch (e) { return null } }

  const [testSendingDialog, setTestSendingDialog] = useState(false)
  const [testSendingEmail, setTestSendingEmail] = useState("")

  const [saveTemplateDialog, setSaveTemplateDialog] = useState(false)
  const [newTemplateName, setNewTemplateName] = useState("")
  const [isSavingNewTemplate, setIsSavingNewTemplate] = useState(false)

  const [openTemplateDialog, setOpenTemplateDialog] = useState(false)
  const [allTemplates, setAllTemplates] = useState([])

  const [mailName, setMailName] = useState("")
  const [mailObject, setMailObject] = useState("")
  const [mailDest, setMailDest] = useState("all")
  const [timingSource, setTimingSource] = useState("openDate")
  const [envoi, setEnvoi] = useState({ jours: 0, sens: "apres", heure: 9 })

  /* Le contenu, au format Rising Up. `ancienFormat` : l'email a ete fait avec
     Unlayer et n'est pas reecrit ; on n'envoie alors ni son contenu ni son
     HTML au serveur, qui les garde tels quels. */
  const [contenu, setContenu] = useState(contenuVide())
  const [ancienFormat, setAncienFormat] = useState(false)
  const [largeurApercu, setLargeurApercu] = useState(620)
  /* Un nouvel email commence par le choix d'un type (preremplit tout). */
  const [typeChoisi, setTypeChoisi] = useState(false)
  const origine = typeof window !== "undefined" ? window.location.origin : ""

  /* Prerempli UNE fois par email ouvert : la liste se recharge quand un autre
     email du groupe part (socket), et ecrasait la saisie en cours. */
  const preremplPour = useRef(null)
  useEffect(() => {
    if (!existant || preremplPour.current === existant.id) return
    preremplPour.current = existant.id
    setMailName(existant.name)
    setMailObject(existant.mailObject)
    setMailDest(existant.mailDest)
    setTimingSource(existant.timingSource)
    setEnvoi(depuisChamps(existant))
    const json = lireJSON(existant.mailJSON)
    if (estContenuRisingUp(json)) { setContenu(contenuComplet(json)); setAncienFormat(false) }
    else { setAncienFormat(true) }
  }, [mailings, actEditMailing])

  const champsEnvoi = versChamps(envoi)
  const dateEnvoi = (() => {
    if (!moduleInfos?.[timingSource]) return null
    const d = Moment(moduleInfos[timingSource], "YYYY-MM-DD")
    d[champsEnvoi.deltaTimingOperator === "+" ? "add" : "subtract"](champsEnvoi.deltaTimingNbr, "days")
    d.add(champsEnvoi.deltaTimingNbr2, "hours")
    return d
  })()
  const dateDansLePasse = !dateEnvoi || dateEnvoi.isBefore(Moment())
  /* une date passee ne bloque que si on la change (un ancien email dont on
     ne touche pas la date garde la sienne) */

  const contenuJSON = JSON.stringify(contenu)
  const valeurs = () => corpsDeRequete({
    existant, groupeID, contentID: moduleInfos.id, name: mailName, mailObject, mailDest, timingSource, envoi,
    finalTiming: dateEnvoi ? dateEnvoi.toISOString(true) : undefined, ancienFormat, contenu, origine,
  })

  const haveToSave = !existant || (
    mailName !== existant.name || mailObject !== existant.mailObject || mailDest !== existant.mailDest ||
    envoiChange(existant, { envoi, timingSource }) ||
    (!ancienFormat && contenuJSON !== existant.mailJSON))

  /* Deja envoye (le statut a pu changer pendant l'edition) : on ne reprogramme
     pas, le serveur le renverrait a tout le groupe. */
  const dejaEnvoye = !!existant && existant.status !== "todo"
  const [enCours, setEnCours] = useState(false)

  const contenuRempli = ancienFormat || (contenu.titre.trim().length > 0 && contenu.texte.trim().length > 0)
  const boutonIncomplet = !ancienFormat && (!!contenu.bouton.libelle.trim() !== !!contenu.bouton.lien.trim() || (contenu.bouton.lien.trim() && !lienValide(contenu.bouton.lien)))
  const peutEnregistrer = !mailObject.includes("[Prénom et nom]") && haveToSave && mailName.trim().length >= 3 && mailObject.trim().length >= 3 && contenuRempli && !boutonIncomplet && !(dateDansLePasse && envoiChange(existant, { envoi, timingSource })) && !dejaEnvoye && !enCours

  const enregistrer = () => {
    if (enCours) return
    setEnCours(true)
    const corps = valeurs()
    const appel = existant ? APIS.editMailing(corps) : APIS.addMailing(corps)
    appel.then((result) => {
      setEnCours(false)
      if (result?.isOk) { getMailingForThisContent(); onClose() }
      else alert("L'email n'a pas pu être enregistré. Réessayez.")
    })
  }

  const changer = (cle, valeur) => setContenu((c) => ({ ...c, [cle]: valeur }))
  const changerBouton = (cle, valeur) => setContenu((c) => ({ ...c, bouton: { ...c.bouton, [cle]: valeur } }))
  const insererChamp = (lisible) => {
    const zone = texteRef.current
    const t = contenu.texte
    const debut = zone ? zone.selectionStart : t.length
    const fin = zone ? zone.selectionEnd : t.length
    changer("texte", t.slice(0, debut) + lisible + t.slice(fin))
    setTimeout(() => { if (zone) { zone.focus(); zone.selectionStart = zone.selectionEnd = debut + lisible.length } }, 0)
  }
  const reecrire = (source) => {
    setContenu(contenuDepuisUnlayer(source))
    setAncienFormat(false)
  }

  const exemples = {
    "{{first_and_last_name}}": user?.name || "Prénom Nom",
    "{{module_name}}": moduleInfos?.name,
    "{{groupe_name}}": groupeName,
    "{{open_date}}": moduleInfos?.openDate ? Moment(moduleInfos.openDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
    "{{close_date}}": moduleInfos?.closeDate ? Moment(moduleInfos.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
  }
  const htmlApercu = avecExemples(ancienFormat ? (existant?.mailHTML || "") : genererHtml(contenu, { origine }), exemples)

  const choisirType = (type) => {
    const p = preremplir(type, { origine, valeurs: exemples })
    setMailName(p.name); setMailObject(p.mailObject); setMailDest(p.mailDest)
    setTimingSource(p.timingSource); setEnvoi(p.envoi); setContenu(p.contenu)
    setTypeChoisi(true)
  }
  const choixDuType = !existant && !typeChoisi

  const loadAllTemplates = () => {
    APIS.getMailingTemplates().then((results) => {
      if (results?.templates) setAllTemplates(results?.templates)
      else alert("Les modèles n'ont pas pu être chargés.")
    })
  }

  return (
    <Box sx={{ padding:"20px", height: "calc(100vh - 64px)", boxSizing:"border-box" }}>
      <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <Box sx={{fontSize:"22px", fontWeight:"bold"}}>
          {existant ? "Modifier l'email" : "Nouvel email"}{mailName ? ` « ${mailName} »` : ""}
          <font style={{fontSize:"15px", fontWeight:"normal", marginLeft:"8px"}}>{subTitle}</font>
        </Box>
        <XIcon width="20px" height="20px" onClick={onClose} style={{ cursor:"pointer", color:"black" }}/>
      </Box>

      <Box sx={{display:"flex", height:"calc(100% - 40px)", paddingTop:"16px", gap:"24px"}}>
        {choixDuType && (
          <Box sx={{flex: 1, overflowY:"auto"}} data-choix-type>
            <Box sx={{fontSize:"18px", marginBottom:"16px"}}>Quel email voulez-vous envoyer&nbsp;?</Box>
            <Box sx={{display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(260px, 1fr))", gap:"14px"}}>
              {TYPES_EMAIL.map((t) => (
                <Box key={t.cle} data-type-email={t.cle} onClick={() => choisirType(t)}
                  sx={{ border:"1px solid #E8E1D6", background:"white", padding:"18px", cursor:"pointer", "&:hover": { borderColor:"#0A0A0B" } }}>
                  <Box sx={{fontSize:"17px", marginBottom:"6px"}}>{t.nom}</Box>
                  <Box sx={{fontSize:"14px", color:"#5A544D", lineHeight:1.45}}>{t.explication}</Box>
                </Box>
              ))}
            </Box>
            <Box sx={{marginTop:"14px", fontSize:"13px", color:"#8A8480"}}>Tout reste modifiable ensuite.</Box>
          </Box>
        )}
        {!choixDuType && <>
        {/* ── LE FORMULAIRE ─────────────────────────────────────────── */}
        <Box sx={{flex: "0 0 440px", height:"100%", overflowY:"auto", paddingRight:"8px"}}>
          <Box sx={STYLE_BLOC}>
            <Box sx={STYLE_LIBELLE}>Nom de l'email <font style={{fontWeight:"normal", color:"#8A8480"}}>(visible par vous seul)</font></Box>
            <TextField fullWidth size="small" value={mailName} onChange={(e) => setMailName(e.target.value)} placeholder="Ex. : Relance J+3" />
          </Box>
          <Box sx={STYLE_BLOC}>
            <Box sx={STYLE_LIBELLE}>Objet</Box>
            <TextField fullWidth size="small" value={mailObject} onChange={(e) => setMailObject(e.target.value)}
              onBlur={() => setMailObject(objetAvecValeurs(mailObject, { ...exemples, "{{first_and_last_name}}": "[Prénom et nom]" }))}
              placeholder="Ce que l'apprenant lit dans sa boîte" />
            {mailObject.includes("[Prénom et nom]") && <Box sx={{marginTop:"6px", fontSize:"13px", color:"#C0392B"}}>Le prénom ne peut pas aller dans l'objet&nbsp;: mettez-le dans le titre.</Box>}
          </Box>
          <Box sx={STYLE_BLOC}>
            <Box sx={STYLE_LIBELLE}>Destinataires</Box>
            <FormControl fullWidth size="small">
              <Select value={mailDest} onChange={(e) => setMailDest(e.target.value)}>
                <MenuItem value="all">Tous les apprenants du groupe</MenuItem>
                <MenuItem value="notStarted">Ceux qui n'ont pas commencé le module</MenuItem>
                <MenuItem value="inProgress">Ceux qui l'ont commencé sans le finir</MenuItem>
                <MenuItem value="ended">Ceux qui l'ont terminé</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{...STYLE_BLOC, paddingBottom:"18px", borderBottom:"1px solid #E8E1D6"}}>
            <Box sx={STYLE_LIBELLE}>Envoi</Box>
            <Box sx={{display:"flex", flexWrap:"wrap", alignItems:"center", gap:"8px", fontSize:"15px"}}>
              <TextField size="small" type="number" inputProps={{ min: 0, max: 90, "data-envoi": "jours" }} sx={{width:"80px"}}
                value={envoi.jours} onChange={(e) => setEnvoi({ ...envoi, jours: Math.min(90, Math.max(0, parseInt(e.target.value, 10) || 0)) })} />
              jour{envoi.jours > 1 ? "s" : ""}
              <FormControl size="small">
                <Select value={envoi.sens} onChange={(e) => setEnvoi({ ...envoi, sens: e.target.value })}>
                  <MenuItem value="avant">avant</MenuItem>
                  <MenuItem value="apres">après</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small">
                <Select value={timingSource} onChange={(e) => setTimingSource(e.target.value)}>
                  <MenuItem value="openDate">l'ouverture du module</MenuItem>
                  <MenuItem value="closeDate">la fermeture du module</MenuItem>
                </Select>
              </FormControl>
              à
              <FormControl size="small">
                <Select value={envoi.heure} onChange={(e) => setEnvoi({ ...envoi, heure: e.target.value })}>
                  {[...Array(24)].map((x, h) => <MenuItem key={h} value={h}>{h} h</MenuItem>)}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{marginTop:"10px", fontSize:"14px", color: dateDansLePasse ? "#C0392B" : "#2A2520"}}>
              {dateEnvoi
                ? <>Envoyé le <b>{dateEnvoi.format("dddd D MMMM YYYY [à] H [h]")}</b>{dateDansLePasse && " : cette date est passée, choisissez-en une autre."}</>
                : "Le module n'a pas de date pour cet envoi."}
            </Box>
          </Box>

          {dejaEnvoye && (
            <Box sx={{...STYLE_BLOC, padding:"14px", background:"#FFFCF8", borderLeft:"4px solid #C0392B", fontSize:"14px"}}>
              Cet email est déjà parti&nbsp;: il ne peut plus être modifié.
            </Box>
          )}
          {ancienFormat ? (
            <Box sx={{...STYLE_BLOC, padding:"14px", background:"#FFFCF8", borderLeft:"4px solid #E26438", fontSize:"14px", lineHeight:1.5}}>
              Cet email a été fait avec l'ancien éditeur : il partira tel quel. Vous pouvez changer
              son objet, ses destinataires et sa date sans toucher à son contenu.
              <Box sx={{marginTop:"10px"}}>
                <Button variant="contained" size="small" onClick={() => reecrire(lireJSON(existant?.mailJSON))}>
                  Réécrire avec le nouvel éditeur
                </Button>
              </Box>
            </Box>
          ) : (
            <>
              <Box sx={STYLE_BLOC}>
                <Box sx={STYLE_LIBELLE}>Petit titre <font style={{fontWeight:"normal", color:"#8A8480"}}>(en orange, au-dessus du titre, facultatif)</font></Box>
                <TextField fullWidth size="small" value={contenu.rubrique} onChange={(e) => changer("rubrique", e.target.value)} placeholder="Ex. : Dernière ligne droite" />
              </Box>
              <Box sx={STYLE_BLOC}>
                <Box sx={STYLE_LIBELLE}>Titre</Box>
                <TextField fullWidth size="small" value={contenu.titre} onChange={(e) => changer("titre", e.target.value)} placeholder="Ex. : Votre module vous attend" />
              </Box>
              <Box sx={STYLE_BLOC}>
                <Box sx={STYLE_LIBELLE}>Texte <font style={{fontWeight:"normal", color:"#8A8480"}}>(une ligne vide = un nouveau paragraphe)</font></Box>
                <TextField fullWidth multiline minRows={7} inputRef={texteRef}
                  /* le theme fixe la hauteur des champs (50-60 px) : un texte de plusieurs lignes debordait */
                  sx={{ "& .MuiInputBase-root": { height: "auto !important", alignItems: "flex-start" } }} value={contenu.texte} onChange={(e) => changer("texte", e.target.value)} />
                <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px", marginTop:"8px"}}>
                  {CHAMPS.map((c) => (
                    <Button key={c.tag} size="small" variant="outlined" sx={{minHeight:"28px !important", padding:"2px 8px", fontSize:"12px", textTransform:"none"}}
                      onClick={() => insererChamp(c.lisible)}>
                      + {c.lisible.slice(1, -1)}
                    </Button>
                  ))}
                </Box>
              </Box>
              <Box sx={STYLE_BLOC}>
                <Box sx={STYLE_LIBELLE}>Bouton <font style={{fontWeight:"normal", color:"#8A8480"}}>(facultatif)</font></Box>
                <Box sx={{display:"flex", gap:"8px"}}>
                  <TextField size="small" sx={{flex:"0 0 160px"}} value={contenu.bouton.libelle} onChange={(e) => changerBouton("libelle", e.target.value)} placeholder="Libellé" />
                  <TextField size="small" sx={{flex:1}} value={contenu.bouton.lien} onChange={(e) => changerBouton("lien", e.target.value)} placeholder="https://…" />
                </Box>
                {boutonIncomplet && <Box sx={{marginTop:"6px", fontSize:"13px", color:"#C0392B"}}>Il faut un libellé et un lien commençant par https://.</Box>}
              </Box>
              <Box sx={STYLE_BLOC}>
                <Box sx={STYLE_LIBELLE}>Signature <font style={{fontWeight:"normal", color:"#8A8480"}}>(sous le bouton)</font></Box>
                <TextField fullWidth multiline minRows={2} value={contenu.signature} onChange={(e) => changer("signature", e.target.value)}
                  sx={{ "& .MuiInputBase-root": { height: "auto !important", alignItems: "flex-start" } }} />
              </Box>
            </>
          )}

          <Box sx={{display:"flex", gap:"10px", flexWrap:"wrap", paddingTop:"14px", borderTop:"1px solid #E8E1D6"}}>
            <Button variant="contained" disabled={!peutEnregistrer} onClick={enregistrer}>
              {existant ? "Enregistrer" : "Créer l'email"}
            </Button>
            <Button variant="outlined" disabled={!existant || haveToSave} onClick={() => setTestSendingDialog(true)}
              title={haveToSave ? "Enregistrez d'abord l'email" : undefined}>
              M'envoyer un test
            </Button>
            <Button variant="outlined" onClick={() => { loadAllTemplates(); setOpenTemplateDialog(true) }}>Partir d'un modèle</Button>
            <Button variant="outlined" disabled={ancienFormat || !contenuRempli} onClick={() => setSaveTemplateDialog(true)}>Garder comme modèle</Button>
          </Box>
        </Box>

        {/* ── L'APERCU ──────────────────────────────────────────────── */}
        <Box sx={{flex: 1, height:"100%", display:"flex", flexDirection:"column", borderLeft:"1px solid #E8E1D6", paddingLeft:"24px", minWidth:0}}>
          <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px"}}>
            <Box sx={{fontSize:"14px", color:"#5A544D"}}>Aperçu{mailObject ? <> · Objet : <b>{mailObject}</b></> : ""}</Box>
            <Box sx={{display:"flex", gap:"6px"}}>
              <Button size="small" variant={largeurApercu === 620 ? "contained" : "outlined"} sx={{minHeight:"28px !important"}} onClick={() => setLargeurApercu(620)}>Ordinateur</Button>
              <Button size="small" variant={largeurApercu === 375 ? "contained" : "outlined"} sx={{minHeight:"28px !important"}} onClick={() => setLargeurApercu(375)}>Téléphone</Button>
            </Box>
          </Box>
          <Box sx={{flex:1, background:"#EFEAE3", display:"flex", justifyContent:"center", overflow:"auto"}}>
            <iframe title="Aperçu de l'email" data-apercu-email srcDoc={htmlApercu} sandbox=""
              style={{ width: largeurApercu + "px", maxWidth:"100%", height:"100%", border:0, background:"#F7F3EE" }} />
          </Box>
        </Box>
        </>}
      </Box>

      {/* M'ENVOYER UN TEST */}
      <Dialog fullWidth maxWidth="sm" open={testSendingDialog} onClose={() => {}} PaperProps={{ sx : { color:"black" } }}>
        <Box sx={{ padding:"20px" }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"22px", fontWeight:"bold"}}>M'envoyer un test</Box>
            <XIcon width="20px" height="20px" onClick={() => { setTestSendingEmail(""); setTestSendingDialog(false) }} style={{ cursor:"pointer", color:"black" }}/>
          </Box>
          <Box sx={{marginTop:"24px", display:"flex", alignItems:"center", gap:"10px"}}>
            Adresse&nbsp;: <TextField value={testSendingEmail} size="small" sx={{flex:1}} onChange={(e) => setTestSendingEmail(e.target.value)}/>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", gap:"20px", marginTop:"30px"}}>
            <Button variant="outlined" onClick={() => { setTestSendingEmail(""); setTestSendingDialog(false) }}>Fermer</Button>
            <Button variant="contained" disabled={!isEmail(testSendingEmail)} onClick={() => {
              APIS.testSendingMailing({id : actEditMailing, email : testSendingEmail, userName : user.name}).then((result) => {
                setTestSendingEmail(""); setTestSendingDialog(false)
                alert(result?.isOk === true ? "Email de test envoyé." : "L'email de test n'a pas pu partir.")
              })
            }}>Envoyer</Button>
          </Box>
        </Box>
      </Dialog>

      {/* GARDER COMME MODELE */}
      <Dialog fullWidth maxWidth="sm" open={saveTemplateDialog} onClose={() => {}} PaperProps={{ sx : { color:"black" } }}>
        <Box sx={{ padding:"20px" }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"22px", fontWeight:"bold"}}>Garder comme modèle</Box>
            <XIcon width="20px" height="20px" onClick={() => { if (!isSavingNewTemplate) { setNewTemplateName(""); setSaveTemplateDialog(false) } }} style={{ cursor:"pointer", color:"black" }}/>
          </Box>
          <Box sx={{marginTop:"24px", display:"flex", alignItems:"center", gap:"10px"}}>
            Nom du modèle&nbsp;: <TextField value={newTemplateName} size="small" sx={{flex:1}} onChange={(e) => setNewTemplateName(e.target.value)}/>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", gap:"20px", marginTop:"30px"}}>
            <Button variant="outlined" onClick={() => { if (!isSavingNewTemplate) { setNewTemplateName(""); setSaveTemplateDialog(false) } }}>Fermer</Button>
            <Button variant="contained" disabled={newTemplateName.trim().length < 3 || isSavingNewTemplate} onClick={() => {
              setIsSavingNewTemplate(true)
              APIS.addMailingTemplate({ name : newTemplateName, json : contenuJSON }).then((result) => {
                setIsSavingNewTemplate(false)
                if (result?.isOk) {
                  if (result?.templates) setAllTemplates(result?.templates)
                  setNewTemplateName(""); setSaveTemplateDialog(false)
                } else alert("Le modèle n'a pas pu être enregistré.")
              })
            }}>
              Garder
              {isSavingNewTemplate && <img src={loadingGIF} style={{marginLeft:"10px", height:"25px"}}/>}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* PARTIR D'UN MODELE */}
      <Dialog fullWidth maxWidth="md" open={openTemplateDialog} onClose={() => {}} PaperProps={{ sx : { color:"black" } }}>
        <Box sx={{ padding:"20px" }}>
          <Box sx={{display:"flex", justifyContent:"space-between"}}>
            <Box sx={{fontSize:"22px", fontWeight:"bold"}}>Partir d'un modèle</Box>
            <XIcon width="20px" height="20px" onClick={() => setOpenTemplateDialog(false)} style={{ cursor:"pointer", color:"black" }}/>
          </Box>
          <TableContainer sx={{marginTop:"20px"}} component={Paper}>
            <Table sx={{ minWidth: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell>Nom</TableCell>
                  <TableCell sx={{width:"140px"}}>Créé le</TableCell>
                  <TableCell align="center" sx={{width:"90px"}}>Supprimer</TableCell>
                  <TableCell align="center" sx={{width:"90px"}}>Utiliser</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allTemplates.map((row) => {
                  const json = lireJSON(row.json)
                  return (
                    <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.name}
                        {!estContenuRisingUp(json) && <font style={{color:"#8A8480", fontSize:"12px"}}> · ancien éditeur, le texte sera repris</font>}
                      </TableCell>
                      <TableCell sx={{width:"140px"}}>{Moment(row.createdAt).format("DD/MM/YYYY HH:mm")}</TableCell>
                      <TableCell align="center" sx={{padding:0}}>
                        <TrashIcon style={{cursor: "pointer"}} color="black" size={21} onClick={() => {
                          muiConfirm({ title: "Supprimer ce modèle ?", description: "La suppression d'un modèle est définitive.", confirmationText:"Supprimer", cancellationText:"Annuler"})
                            .then(() => {
                              APIS.removeMailingTemplate({id : row.id}).then((result) => {
                                if (result?.isOk === true) { if (result?.templates) setAllTemplates(result?.templates) }
                                else alert("Le modèle n'a pas pu être supprimé.")
                              })
                            }).catch(() => {})
                        }}/>
                      </TableCell>
                      <TableCell align="center" sx={{padding:0}}>
                        <DownloadIcon style={{cursor: "pointer"}} color="black" size={21} onClick={() => {
                          muiConfirm({ title: "Utiliser ce modèle ?", description: "Le titre, le texte et le bouton actuels seront remplacés.", confirmationText:"Utiliser", cancellationText:"Annuler"})
                            .then(() => {
                              if (estContenuRisingUp(json)) { setContenu(json); setAncienFormat(false) }
                              else reecrire(json)
                              setOpenTemplateDialog(false)
                            }).catch(() => {})
                        }}/>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{display:"flex", justifyContent:"center", marginTop:"30px"}}>
            <Button variant="outlined" onClick={() => setOpenTemplateDialog(false)}>Fermer</Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  )
}

const GroupMailing = ({ groupeName, groupeID, moduleInfos, hasChanged, updateMailingLists }) => {
  const muiConfirm = useConfirm();

  const socket = useContext(SocketContext)
  const { currentUser } = useContext(UserContext)

  const [dialogOpen, setDialogOpen] = useState(false)
  const [actEditMailing, setActEditMailing] = useState(null)

  const [mailings, setMailings] = useState([])

  if (groupeID === null || groupeID === undefined) {
    hasChanged = true
  }

  const getMailingForThisContent = () => {
    if (groupeID !== undefined && moduleInfos?.id !== undefined) {
      APIS.getMailingByGroupAndContent({groupeID : groupeID, contentID : moduleInfos?.id}).then((results) => {
        if (results?.isOk && results?.mailings) {
          setMailings(results?.mailings)
        } else {
          alert("Error get mailing")
        }
      })
    }
  }

  useEffect(() => {
    getMailingForThisContent()
  }, [moduleInfos])

  useEffect(() => {
    updateMailingLists({moduleID : moduleInfos.id, length : mailings.length, uuid : moduleInfos.uuid})
  }, [mailings])

  useEffect(() => {
    const updateMailingStatusEvent = (data) => {
      try {
        if (data?.groupeID === groupeID && data.contentID === moduleInfos.id) {
          getMailingForThisContent()
        }
      } catch(e) { console.log(e) }
    }
    socket?.on("updateMailingStatus", updateMailingStatusEvent)
    return () => {
      socket?.off("updateMailingStatus", updateMailingStatusEvent)
    }
  }, [])

  return (
    <>
      <Divider />
      <Box
        sx={{padding:"10px", opacity: hasChanged ? 0.4 : 1}}
        onClick={() => {
          if (hasChanged) {
            alert("Enregister les modifications avant de pouvoir éditer les mailings")
          }
        }}
      >
        <Button style={{display:"none"}} className="getMailingForThisContentClick" onClick={() => { getMailingForThisContent() }} />
        <Box sx={{width:"100%", display:"flex", flexDirection:"column"}}>
          <TableContainer sx={{marginBottom:"10px"}} component={Paper}>
            <Table sx={{ minWidth: "100%" }} size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell><font style={{fontSize:"16px"}}>Mailing</font> - Nom</TableCell>
                  <TableCell sx={{width:"200px"}}>Timing</TableCell>
                  <TableCell sx={{width:"90px"}}>Destinataires</TableCell>
                  <TableCell sx={{width:"60px"}}>Status</TableCell>
                  <TableCell align="center" sx={{width:"45px"}}>Edit</TableCell>
                  <TableCell align="center" sx={{width:"45px"}}>Suppr</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mailings.map((mailing, index) => {
                  return (
                    <TableRow
                      key={mailing.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {mailing.name}
                      </TableCell>
                      <TableCell sx={{width:"200px"}}>
                        {mailing.deltaTimingUnit2}{mailing.deltaTimingOperator2}{mailing.deltaTimingNbr2}
                        {" et "}
                        {mailing.deltaTimingUnit}{mailing.deltaTimingOperator}{mailing.deltaTimingNbr}
                        {", "}
                        {mailing.timingSource === "closeDate" && "date de fin"}
                        {mailing.timingSource === "openDate" && "date de début"}
                        <br/>
                        ({Moment(mailing.finalTiming).format("DD/MM/YYYY HH:mm")})
                      </TableCell>
                      <TableCell sx={{width:"90px"}}>
                        {mailing.mailDest === "all" && "Tous"}
                        {mailing.mailDest === "notStarted" && "N'ayant pas commencé"}
                        {mailing.mailDest === "inProgress" && "En cours"}
                        {mailing.mailDest === "ended" && "Ayant terminé"}
                      </TableCell>
                      <TableCell sx={{width:"60px"}}>
                        {mailing.status === "todo" &&
                          <font
                            color="orange"
                            style={{cursor: !hasChanged && "pointer", userSelect:"none"}}
                            onClick={() => {
                              if (!hasChanged) {
                                muiConfirm({ title: "Êtes-vous sûrs\u00a0?", description: "Voulez-vous vraiment forcer l'envoi\u00a0?", confirmationText:"Envoyer", cancellationText:"Annuler"})
                                  .then(() => {
                                    APIS.forceSendingMailing({id : mailing.id }).then((result) => {
                                      if (result?.isOk === true) {
                                        getMailingForThisContent()
                                        alert("Mailing traité")
                                      } else {
                                        alert("Error")
                                      }
                                    })
                                  })
                                  .catch(() => { });
                              }
                            }}
                          >
                            À traiter
                          </font>
                        }
                        {mailing.status === "ok" && <font color="green">Traité</font>}
                      </TableCell>
                      <TableCell align="center" sx={{padding:0, width:"45px"}}>
                        {mailing.status === "todo" &&
                          <EditIcon
                            style={{cursor: !hasChanged && "pointer"}}
                            color="black"
                            size={21}
                            onClick={() => {
                              if (!hasChanged) {
                                setActEditMailing(mailing.id)
                                setDialogOpen(true)
                              }
                            }}
                          />
                        }
                      </TableCell>
                      <TableCell align="center" sx={{padding:0, width:"45px"}}>
                        {mailing.status === "todo" &&
                          <TrashIcon
                            style={{cursor: !hasChanged && "pointer"}}
                            color="black"
                            size={21}
                            onClick={() => {
                              if (!hasChanged) {
                                muiConfirm({ title: "Êtes-vous sûrs\u00a0?", description: "La suppression d'un mailing est définitive.", confirmationText:"Supprimer", cancellationText:"Annuler"})
                                  .then(() => {
                                    APIS.removeMailing({id : mailing.id, groupeID : groupeID, contentID : moduleInfos.id}).then((result) => {
                                      if (result?.isOk === true) {
                                        if (result?.mailings) { setMailings(result?.mailings) }
                                      } else {
                                        alert("Error")
                                      }
                                    })
                                  })
                                  .catch(() => { });
                                }
                            }}
                          />
                        }
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end"}}>
          <Button
            disabled={hasChanged || moduleInfos && moduleInfos.id === undefined}
            variant="contained"
            sx={{ minHeight:"35px !important" }}
            onClick={() => { setDialogOpen(true)}}
          >
            Créer un mailing
          </Button>
        </Box>


        <Dialog
          fullWidth={true}
          maxWidth={false}
          open={dialogOpen}
          onClose={() => { }}
          PaperProps={{
            sx : {
              color:"black",
            }
          }}
        >
          <DialogContent
            title={"Mailing"}
            moduleInfos={moduleInfos}
            groupeName={groupeName}
            groupeID={groupeID}
            subTitle={"(Groupe "+groupeName+" - Module "+moduleInfos.name+")"}
            onClose={() => { setDialogOpen(false); setActEditMailing(null); }}
            getMailingForThisContent={getMailingForThisContent}
            mailings={mailings}
            actEditMailing={actEditMailing}
            user={currentUser}
          />
        </Dialog>
      </Box>
    </>
  )
};

export default GroupMailing;
